import { Container,  Text, Stack,  Grid } from '@mantine/core'
import { IconFileText} from '@tabler/icons-react'
import { documentsPageStyles } from './DocumentsPage.styles'
export function DocumentsPage() {
  const documents = [
    {
      title: 'Карточка_предприятия_АВТО_ЭКСПЕРТ',
      description: 'Карточка предприятия ООО "Авто Эксперт"',
      type: 'pdf',
      size: '1.2 MB',
      status: 'одобрен',
      link: 'https://auto--expert.ru/docs/карточка_предприятия_АВТО_ЭКСПЕРТ.pdf'
    },
    {
      title: 'Уведовление о перезоде на УСН.pdf',
      description: 'Уведовление о перезоде на УСН',
      type: 'pdf',
      size: '0.5 MB',
      status: 'одобрен',
      link: 'https://auto--expert.ru/docs/Уведовление о переходе на УСН.pdf'
    },
    {
      title: 'СВИДЕТЕЛЬСТВО ФНС',
      description: 'Свидетельство ФНС',
      type: 'pdf',
      size: '0.3 MB',
      status: 'одобрен',
      link: 'https://auto--expert.ru/docs//СВИДЕТЕЛЬСТВО ФНС.pdf'
    },
    {
      title: 'УСТАВ ООО "АВТО ЭКСПЕРТ"',
      description: 'Устав ООО "Авто Эксперт"',
      type: 'pdf',
      size: '0.5 MB',
      status: 'одобрен',
      link: 'https://auto--expert.ru/docs/УСТАВ.pdf'
    }
  ]
  const resolutions = [
    {
      title: '',
      description: 'Постановление Правительства Российской Федерации от 15 сентября 2020г №1434 "Об утверждении Правил проведения технического осмотра транспортных средств, а также о внесении изменений в некоторые акты Правительства Российской Федерации',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/Постановление_Правительства_ТО_№1434.pdf'
    },
    {
      title: '',
      description: 'Федеральный закон Российской Федерации от 1 июля 2011 года N 170-ФЗ г. Москва "О техническом осмотре транспортных средств и о внесении изменений в отдельные законодательные акты Российской Федерации"',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/FZ_170.doc'
    },
    {
      title: '',
      description: 'Приказ Министерства экономического развития Российской Федерации (Минэкономразвития России) от 14 октября 2011 г. N 573 г. Москва "Об утверждении формы типового договора о проведении технического осмотра"',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/minek_573.doc'
    },
    {
      title: '',
      description: 'Приказ Министерства экономического развития Российской Федерации (Минэкономразвития России) от 28 ноября 2011 г. N 697 г. Москва "Об утверждении Правил аккредитации операторов технического осмотра"',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/minek_697.doc'
    },
    {
      title: '',
      description: 'Приказ Министерства промышленности Российской Федерации (Минпромторг России) от 6 декабря 2011 г. N 1677 г. Москва "Об утверждении основных технических характеристик средств технического диагностирования и их перечн',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/minpromtorg_1677.doc'
    },
    {
      title: '',
      description: 'РОССИЙСКАЯ ФЕДЕРАЦИЯ ФЕДЕРАЛЬНЫЙ ЗАКОН О ВНЕСЕНИИ ИЗМЕНЕНИЙ В ОТДЕЛЬНЫЕ ЗАКОНОДАТЕЛЬНЫЕ АКТЫ РОССИЙСКОЙ ФЕДЕРАЦИИ',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/FZ_1303.doc'
    },
    {
      title: '',
      description: 'Постановление Правительства Российской Федерации от 13 ноября 2013 г',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/postanovlenie13102013.doc'
    },
    {
      title: '',
      description: 'Приказ Федеральной службы по финансовым рынкам (ФСФР России) от 6 мая 2013 г. N 13-32/пз-н г. Москва',
      type: '',
      size: '',
      link: 'https://auto--expert.ru/docs/PrikazN%2013-32.doc'
    },

  ]

  return (
    <Container size="xl" py="xl">
      <Stack gap="sm">

        
        <Text size="lg" ta="center" c="dimmed" maw={800} mx="auto" style={{ fontSize: '1.5rem' }}>
          Официальные документы и сертификаты нашей компании
        </Text>


          {documents.map((doc, index) => (
                    <Grid mt="xl" columns={2} key={index} style={documentsPageStyles.documentCard} onClick={() => {window.open(doc.link, '_blank')}} align="center">
                      <Grid.Col  span="content">
<IconFileText size="2rem" />
                      </Grid.Col>
            <Grid.Col span="auto">
              <Text>{doc.description}</Text>
            </Grid.Col>
          </Grid>
          ))}

          <Text size="lg" ta="center" c="dimmed" maw={800} mx="auto" style={{ fontSize: '1.5rem' }} mt="xl">
          Законы, приказы, постановления
        </Text>


          {resolutions.map((doc, index) => (
                    <Grid mt="xl" columns={2} key={index} style={documentsPageStyles.documentCard} onClick={() => {window.open(doc.link, '_blank')}} align="center">
                      <Grid.Col  span="content">
<IconFileText size="2rem" />
                      </Grid.Col>
            <Grid.Col span="auto">
              <Text>{doc.description}</Text>
            </Grid.Col>
          </Grid>
          ))}
      </Stack>

    </Container>
  )
}